"use client";

import { useSearchParams, useRouter } from "next/navigation";
import CustomPagination from "../ui/CustomPagination";

const ProjectsPagination = ({
  page,
  totalPages,
}: {
  page: number;
  totalPages: number;
}) => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const handlePageChange = (page: number) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("page", page.toString());
    router.push(`/projects?${params.toString()}`);
  };

  return (
    <CustomPagination
      pages={totalPages}
      current={page}
      setCurrentPage={handlePageChange}
    />
  );
};

export default ProjectsPagination;
